import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage, AngularFireStorageReference } from '@angular/fire/storage';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as firebase from 'firebase';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { Onderneming } from '../models/Onderneming';
import { AuthService } from '../services/auth.service';
import { DataService } from '../services/data.service';
import { OndernemingService } from '../services/onderneming.service';
import { ModalContentComponent } from '../shared/modal-content/modal-content.component';
import { CustomLinkService } from '../services/custom-link.service';
import { CustomLink } from '../models/CustomLink';
import { ActiveModules } from '../models/Onderneming';
import { FormBuilder, Validators } from '@angular/forms';
import { IFormBuilder, IFormGroup } from '@rxweb/types';

//Nieuw veld per nieuwe module er toegevoegd wordt.
interface OndernemingForm extends CustomLink
{
  algemeneWaarschuwing?:string | null;
  activeModules?: ActiveModules ;

}

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./admin.component.scss'],
})
export class AdminComponent implements OnInit, OnDestroy {
  @ViewChild('Inputfile', { static: false }) fileElement: ElementRef<HTMLInputElement>;
  newLogo: File;
  downloadURL: Observable<string>;
  ondernemingId: string;
  ondernemingNaam: string;
  onderneming$: Observable<Onderneming>;
  kleur: string;
  kleurKnoppen: string;
  user$: Observable<firebase.User>;
  componentDestroyed$ = new Subject();
  ref: AngularFireStorageReference;
  imagePath;




  //gebruik maken van inherit/ extend klasses?
  ondernemingForm: OndernemingForm = {
    omschrijving: '',
    link: '',
    algemeneWaarschuwing:'',
    activeModules:{opzegtermijn: false},

  }
  
  
  //
  // customLink: CustomLink =
  // {
  //   omschrijving: '',
  //   link:''
  // }
  formBuilder: IFormBuilder;
  ondernemingFormGroup: IFormGroup<OndernemingForm>;


  constructor(
    private route: ActivatedRoute,
    private ondernemingService: OndernemingService,
    private r: Router,
    public dataService: DataService,
    private authService: AuthService,
    private afStorage: AngularFireStorage,
    private afStore: AngularFirestore,
    private cd: ChangeDetectorRef,
    private modalService: NgbModal,
    private customLinkService: CustomLinkService,
    formBuilder: FormBuilder,


  ) {
    this.formBuilder = formBuilder
  }
  //public reg = '(https?://)([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  ngOnInit(): void {
    this.user$ = this.authService.getUser();
    
    this.ondernemingFormGroup = this.formBuilder.group<OndernemingForm>({
      link : this.formBuilder.control(null),
      //link : this.formBuilder.control(null,[Validators.pattern(this.reg)]),
      omschrijving: this.formBuilder.control(null,[Validators.maxLength(30) ]),
      algemeneWaarschuwing : this.formBuilder.control(null),
      activeModules: this.formBuilder.group({
        opzegtermijn: false,
        test: false
      }),
    })

    //this.ondernemingId = this.route.snapshot.parent.paramMap.get('ondernemingId');
    this.ondernemingNaam = this.route.snapshot.parent.paramMap.get('ondernemingNaam');
    this.onderneming$ = this.ondernemingService.streamOndernemingNaam(this.ondernemingNaam).pipe(takeUntil(this.componentDestroyed$));
    this.onderneming$.subscribe(onderneming => {
      // TODO: maybe use a FormGroup for this instead
      this.ondernemingForm = onderneming
      this.kleur = onderneming.kleur;
      this.kleurKnoppen = onderneming.kleurKnoppen;
      this.getCustomLink(onderneming.customLink);
      this.cd.markForCheck();
    });


  }

  getCustomLink(id: string) {

    if (this.dataService.customLink === undefined) {
      this.customLinkService.getCustomLink(id).pipe(
        takeUntil(this.componentDestroyed$))
        .subscribe(e => {
          this.ondernemingForm.link = e.link;
          this.ondernemingForm.omschrijving = e.omschrijving;
          this.cd.markForCheck();
        });

    }
    else {
      this.ondernemingForm.link = this.dataService.customLink.link ;
      this.ondernemingForm.omschrijving = this.dataService.customLink.omschrijving;
    }
  }

  // set primair kleur
  setKleur(event: any) {
    this.kleur = event;
  }

  // set secundair kleur
  setKleurKnoppen(event: any) {
    this.kleurKnoppen = event;
  }

  // opslaan van gegevens
  async onSubmit() {
    if (this.ondernemingFormGroup.invalid) {
      return;
    }
    const modalRef = this.modalService.open(ModalContentComponent);
    modalRef.componentInstance.confirmationBoxTitle = 'Bevestiging';
    modalRef.componentInstance.confirmationMessage = 'Weet u zeker dat u deze gegevens wilt opslaan?';
    const userResponse = await modalRef.result;
    if (userResponse) {
      await this.save();
    }
  }

  async save() {

    this.onderneming$.pipe(take(1)).subscribe(async onderneming => {
      try {
        const updatedOnderneming = { ...onderneming , kleur: this.kleur, kleurKnoppen: this.kleurKnoppen, 
          algemeneWaarschuwing: this.ondernemingForm.algemeneWaarschuwing, activeModules: this.ondernemingForm.activeModules };
          
          
          if (this.newLogo) {
          // Delete old logo
          if (onderneming.logo_id) {
            try {
              await this.ondernemingService.deleteLogo(onderneming.logo_id);
            } catch (e) {
              console.log('Failed to delete logo, ignoring error');
              console.error(e);
            }
          }
          // Create id for the new logo
          const newLogoId = this.afStore.createId();
          updatedOnderneming.logo_id = newLogoId;
          // Upload the new logo, when done update the onderneming with the new logo id
          this.uploadLogo(newLogoId).then(async () => {
            // TODO error handling (try/catch)
            await this.ondernemingService.updateOnderneming(updatedOnderneming);
          });
        } else {
          await this.ondernemingService.updateOnderneming(updatedOnderneming);
        }
        //Updaten van de customLink
        
      } catch (err) {
        console.log(err);
      }

      // TODO error in customLink wanneer je ook iets aanpast aan de ondernemingsData
      var customLink: CustomLink = {
        link: this.ondernemingForm.link,
        omschrijving:this.ondernemingForm.omschrijving,
        id: onderneming.customLink
        }
        this.customLinkService.updateCustomLink(customLink)
        
    });
    
    
  }

  uploadLogo(id: string) {
    this.ref = this.afStorage.ref(id);
    return this.ref.put(this.newLogo);
  }

  // Uploaden van een logo
  upload($event: File) {
    const logo = $event;

    if (logo) {
      if (logo.size > 5242880) {
        const fileSize = (Math.round(logo.size * 100 / (1024 * 1024)) / 100).toString() + 'MB';
        const modalRef = this.modalService.open(ModalContentComponent);

        modalRef.componentInstance.confirmationBoxTitle = 'Error';
        modalRef.componentInstance.confirmationMessage = 'bestand moet kleiner zijn dan 5MB! Dit bestand is ' + fileSize;
        modalRef.componentInstance.bevestig = false;
        this.resetUpload();
      } else {
        this.newLogo = logo;
        const reader = new FileReader();
        reader.readAsDataURL(this.newLogo);
        reader.onload = e => {
          this.imagePath = reader.result;
          this.cd.markForCheck();
        };
      }
    }

  }

  resetUpload() {
    this.fileElement.nativeElement.value = null;
  }


  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }

}
